<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import type { Tab } from '$lib/models/tab';
  import { createEventDispatcher } from 'svelte';
  import { translation } from '$lib/locale/locale';

  export let tabs: Tab[];

  export let selectedTab: Tab;
  export let showViewAll = false;

  export let position: 'center' | 'left' | 'right' | 'fill' = 'center';
  export let borderBottom = 'none';
  export let tabMarginBottom = '0';
  export let padding = '0';
  export let tabPadding = '1rem 1.5rem';
  export let inactiveColor = 'var(--black-coral)';
  export let inactiveBorderBottom = '0.2rem solid var(--line-grey)';
  export let activeColor = 'var(--magic-potion)';
  export let activeBorderBottom = '0.2rem solid var(--magic-potion)';
  export let pillBackground = 'linear-gradient(90deg, #CB75FF 0%, #D95ED4 100%)';
  export let stacked = false;
  export let showPills = true;

  const { langHref } = translation();

  if (!selectedTab && tabs?.length > 0) {
    selectedTab = tabs[0];
  }

  const dispatch = createEventDispatcher();
  function changeSelectedTab(tab: Tab) {
    dispatch('tabChanged', {
      tab: tab,
    });
  }

  function setSelected(tab: Tab) {
    selectedTab = tab;
    changeSelectedTab(selectedTab);
  }

  $: justifyContent =
    position === 'center' ? 'center' : position == 'fill' ? 'space-evenly' : position === 'left' ? 'flex-start' : 'flex-end';
</script>

<div class:tabs-row={showViewAll} class:stacked class:fill={position === 'fill'}>
  {#if showViewAll}
    <div class="view-all"></div>
  {/if}
  <ul class="nav nav-pills" style="border-bottom: {borderBottom}; justify-content: {justifyContent}; padding: {padding}">
    {#each tabs as tab (tab.id)}
      <li class="nav-item tab">
        <button
          on:click={() => setSelected(tab)}
          disabled={tab.disabled}
          style="color: {tab.id === selectedTab.id ? activeColor : inactiveColor};
                  border-bottom: {tab.id === selectedTab.id ? activeBorderBottom : inactiveBorderBottom};
                  margin-bottom: {tabMarginBottom};
                  padding: {tabPadding};"
        >
          {#if tab.icon}
            <img class="icon" class:icon-selected={selectedTab.id === tab.id} src={tab.icon} alt="" aria-hidden="true" />
          {/if}
          {tab.name}
          {#if tab.pill && showPills}
            <b style="background: {pillBackground};" class="pill">{tab.pill}</b>
          {/if}
        </button>
      </li>
    {/each}
  </ul>
  {#if showViewAll}
    <a class="view-all" href={langHref('/royalty-free-music/')}>{m['actions.view-all']().toUpperCase()}</a>
  {/if}
</div>

<style>
  .tabs-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tabs-row .view-all {
    font-weight: 700;
    font-size: var(--xs-font-size);
    color: var(--magic-potion);
    margin-left: 1.3rem;
    width: 8rem;
    text-align: right;
  }

  .tab {
    font-size: 1.3rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    cursor: pointer;
    position: relative;
    padding: 0;
  }
  li {
    margin-right: 1rem;
  }

  li:last-child {
    margin-right: 0px;
  }

  li button {
    display: flex;
    align-items: center;
  }

  li button[disabled] {
    cursor: default;
    opacity: 0.65;
  }

  .stacked li button {
    flex-direction: column;
  }

  .stacked li button {
    flex-direction: column;
  }

  .stacked li button img {
    margin: 0;
  }

  .fill li {
    flex: 1;
    margin: 0;
  }

  .fill li button {
    width: 100%;
  }

  .pill {
    border-radius: 16px;
    padding: 4px;
    font-weight: var(--medium-font-weight);
    font-size: 8px;
    line-height: 8px;
    text-transform: uppercase;
    color: white;
    margin-left: 6px;
  }
  .icon {
    margin-right: 8px;
  }

  .icon-selected {
    filter: invert(18%) sepia(8%) saturate(355%) hue-rotate(180deg) brightness(30%) contrast(70%);
  }
  @media (max-width: 900px) {
    .tabs-row {
      justify-content: center;
    }

    .tabs-row .view-all {
      display: none;
    }
  }
</style>
